export const homeObjOne = {
    lightBg: true,
    lightText: false,
    lightTextDesc: false,
    topLine: '',
    headline: 'Travel Safely With Covid Off Your Mind',
    description: 'Our Version of TTC Bus Is Designed To Protect Passengers, Allow Transportation Services While Reducing The Chances Of Catching Covid-19 Virus. The plan for the TTC is designed to incorporate the priority safety guidelines enforced by the Government of Ontario relating to Covid-19 Virus, and the transferability of it.',
    buttonLabel: 'Learn More',
    imgStart: '',
    img: 'images/final.png',
    alt: ''
  };

  export const homeObjTwo = {
    lightBg: true,
    lightText: false,
    lightTextDesc: false,
    topLine: 'Protecting Those Who Are More Susceptible',
    headline: 'Introducing Partitions ',
    description:
      'For this reason, to limit the amount of people susceptible in contracting the virus, we designed the bus in a way where we cut in half as we dividing the bus in 2 compartments connected by a Plastic Fibre Infused Compound Barrier, and a locked door which only a TTC Driver has access. First Compartment allows extensive seating for the elderly, pregnant women and accomodations for persons with disablities.',
    buttonLabel: 'Learn More',
    imgStart: '',
    img: 'images/partition.png',
    alt: 'Vault'
  };
  
  export const homeObjThree = {
    lightBg: false,
    lightText: false,
    lightTextDesc: false,
    topLine: 'Bus Introduces The 360° Standing Pod With Motion Sensor Ledge Technology',
    headline: 'Saying GoodBye To Convention',
    description:
      ' The 360 Pod doubles as a private cubby area for passengers who do not want to take a seat and/or if all seats are taken. With built in sensors which detect whether a pod is occupied or not, along with motion sensors which allow for the use of built in ledge technology. The 360 Pod is providing standing room for 3 passengers all interchanged by 120° around the pod.',
    buttonLabel: 'View More',
    imgStart: 'start',
    img: 'images/standingPod.png',
    alt: ''
  };
  
  export const homeObjFour = {
    lightBg: false,
    lightText: false,
    lightTextDesc: false,
    topLine: 'Due to Covid-19, the gatherings of people in small, enclosed areas are prohibited',
    headline: 'Reducing Seats, While Maintaining Revenue',
    description:
      "With current restrictions on indoor and outdoor spaces, it's best if people maintain safe distance throughout their journey on the bus. Thus, we designed the bus in such a way that it ensured the safety of people by eliminating extra seats, and excess standing rooms, all this while maintaining a moderate amount of passengers in order to maintain revenue.",
    buttonLabel: 'Sign Up Now',
    imgStart: 'start',
    img: 'images/seating.png',
    alt: ''
  };

  export const homeObjFive = {
    lightBg: true,
    lightText: false,
    lightTextDesc: false,
    topLine: 'Using Simple Techonology To Make a Huge Difference',
    headline: 'AI Integration',
    description: 'We designed the bus with integrated AI to assist passengers, in finding seats or designated seating to allow for a safer experience using the bus. Empty Seats will have led pathways leading up to them for the passenger to follow, and safely enter without entering another passenger 2 Feet Radius, cutting the transmission of Covid-19 significantly. ',
    buttonLabel: 'Learn More',
    imgStart: '',
    img: 'images/ai.png',
    alt: ''
  };
  